const Box = ({ children, container = false }) => (
  <div className={`box ${container ? 'box--with-container' : ''}`}>
    {children}
  </div>
)

export default Box